import { message } from 'components';
import { aiAgentCenterMessages } from 'messages';
import { useInterceptAICallSessionMutation } from 'services';
import { CallSessionDto } from 'types';

export const useInterceptAICallSession = () => {
  const [handleIntercept, { isLoading }] = useInterceptAICallSessionMutation();

  const onInterceptCallSession = (callSessionId: number, callBack: (data: CallSessionDto) => void) => {
    return handleIntercept(callSessionId)
      .unwrap()
      .then((res) => {
        message.success(aiAgentCenterMessages.interceptChatSuccess);
        callBack(res.data);
      });
  };

  return {
    onInterceptCallSession,
    isLoading
  };
};
